import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Hanken_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"hankenGrotesk\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer","Bounce"] */ "/vercel/path0/frontend/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/frontend/src/providers/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/styles/globals.css");
